import { render, staticRenderFns } from "./TabularDataset.vue?vue&type=template&id=1fe5a9de&scoped=true"
import script from "./TabularDataset.vue?vue&type=script&lang=js"
export * from "./TabularDataset.vue?vue&type=script&lang=js"
import style0 from "./TabularDataset.vue?vue&type=style&index=0&id=1fe5a9de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe5a9de",
  null
  
)

export default component.exports